import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "MapCellVoteSet" }

import { PropType } from "vue";
import { VoteSet as VoteSetType } from "@/types";
import VoteSet from "@/components/vote-set/VoteSet.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MapCellVoteSet',
  props: {
    voteSet: {
        type: Array as PropType<VoteSetType>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VoteSet, {
      "vote-set": __props.voteSet,
      "is-heavy": "",
      small: "",
      "show-distance": ""
    }, null, 8, ["vote-set"])
  ]))
}
}

})